import { divIcon } from 'leaflet';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { injectIntl } from 'react-intl';
import { Marker, Popup } from 'react-leaflet';
import isEqual from 'lodash.isequal';
import { Button, Div } from 'ui';
import Icon from '../../../ui/icon';
import { mapMarkerSizeConfig } from '../../../utils/app-configs';
import * as styles from './marker.css';

const MapMarker = ({
  intl,
  position, // [lat, long] - e.g [51.505, -0.09]
  icon = 'location-dot', // Any font awesome icon
  size = 'default', // default or small
  popup,
  draggable = false,
  map,
  zoom,
  ...rest
}) => {
  const [positionOnMap, setPositionOnMap] = useState(position);
  const [isDragging, setIsDragging] = useState(false);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!isEqual(position, positionOnMap)) {
      setPositionOnMap(position);
      map?.setView(position, zoom);
    }
  }, [position]);

  const iconSizeConfig = Object.keys(mapMarkerSizeConfig).includes(size) ?
    mapMarkerSizeConfig[size] :
    mapMarkerSizeConfig.default;

  const iconMarkup = renderToStaticMarkup(
    <Icon type={icon} size={iconSizeConfig.faSize} className='fa-fw' />,
  );

  const customIcon = divIcon({
    html: iconMarkup,
    iconSize: iconSizeConfig.iconSize,
    iconAnchor: iconSizeConfig.iconAnchor,
    className: styles.customLeafletDivIcon,
  });

  const dragEndEventHandler = {
    dragend: () => {
      const marker = markerRef.current;
      if (marker) {
        setPositionOnMap(marker.getLatLng());
      }
    },
  };

  const toggleIsDragging = () => {
    setIsDragging(prevState => !prevState);
  };

  if (position?.length !== 2) {
    return null;
  }

  return (
    <Marker
      ref={markerRef}
      position={positionOnMap}
      icon={customIcon}
      draggable={isDragging}
      eventHandlers={dragEndEventHandler}
      {...rest}
    >
      {popup &&
        <Popup
          offset={mapMarkerSizeConfig[size].popupOffset}
        >
          <Div>
            {popup}
          </Div>
          {draggable &&
            <Button onClick={toggleIsDragging}>
              {isDragging ?
                intl.formatMessage({ id: 'geoMap.START_DRAGGING' }) :
                intl.formatMessage({ id: 'geoMap.STOP_DRAGGING' })
              }
            </Button>
          }
        </Popup>
      }
    </Marker>
  );
};

MapMarker.propTypes = {
  intl: PropTypes.object,
  position: PropTypes.array,
  icon: PropTypes.string,
  size: PropTypes.string,
  popup: PropTypes.string,
  draggable: PropTypes.bool,
  map: PropTypes.object,
  zoom: PropTypes.number,
};


export default injectIntl(MapMarker);
